import { z } from 'zod';

import { QUESTION_TYPE } from 'types/question.types';

import { BaseQuestionSchema } from './BaseQuestionSchema';

export const LongAnswerSchema = BaseQuestionSchema.extend({
  type: z.literal(QUESTION_TYPE.LONG)
});

export type LongAnswerFormValues = z.infer<typeof LongAnswerSchema>;

export const LONG_ANSWER_DEFAULTS: LongAnswerFormValues = {
  label: '',
  type: QUESTION_TYPE.LONG,
  isRequired: false
};
